const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/ukbb/eCheckin/sections/PersAngaben.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m, useCIS4mData } from '@cistec/common_web/modules/CIS4m/hooks';
import { CIS4mTextField } from '@cistec/common_web/modules/CIS4m/components/CIS4mTextField';
import textMapCommon from '../../../common/translations';
import textMap from 'App/config/ukbb/eCheckin/translations';
import { AddressBlock, AddressFieldsConfig } from 'App/components/eCheckin/components/fields/AddressBlock';
import { ECheckinSectionProps } from 'App/components/eCheckin/types';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import { createFieldPath } from 'App/components/eCheckin/utils';
import { BirthDateField } from 'App/components/eCheckin/components/fields/BirthDateField';
import { GenderField } from 'App/components/eCheckin/components/fields/metakat/GenderField';
import { CountryField } from 'App/components/eCheckin/components/fields/metakat/CountryField';
import _ from 'lodash';
import { LanguageField } from 'App/components/eCheckin/components/fields/metakat/LanguageField';
import { ReligionField } from 'App/components/eCheckin/components/fields/metakat/ReligionField';
import { AHVField } from 'App/components/eCheckin/components/fields/AHVField';
import { useText } from '@cistec/common_web/utils/intlUtils';
import { validateAHVNoDots } from '@cistec/common_web/components/Forms/utils/validation';

const addressFieldsConfig: AddressFieldsConfig = {
    additionalInfo: { included: false },
};

export const PersAngaben = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);

    const PATH_FIRST_NAME = createFieldPath(path, 'firstname');
    const PATH_LAST_NAME = createFieldPath(path, 'lastname');
    const PATH_DATE_OF_BIRTH = createFieldPath(path, 'dateOfBirth');
    const PATH_GENDER = createFieldPath(path, 'gender');
    const PATH_NATIONALITY = createFieldPath(path, 'nationality');
    const PATH_HOME_TOWN = createFieldPath(path, 'hometown');
    const PATH_LANGUAGE = createFieldPath(path, 'lang');
    const PATH_RELIGION = createFieldPath(path, 'religion');
    const PATH_AHV = createFieldPath(path, 'ahv');

    const eCheckinSectionRef = useCIS4m(ref);
    const formData = useCIS4mData();

    const showHomeTownField = _.get(formData, PATH_NATIONALITY) === 'CH';

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={path} title={title}>
            <h1>{title}</h1>
            <CIS4mTextField label={textMapCommon.firstname} path={PATH_FIRST_NAME} required={true} />
            <CIS4mTextField label={textMapCommon.lastname} path={PATH_LAST_NAME} required={true} />
            <AddressBlock basePath={path} required={true} fieldsConfig={addressFieldsConfig} />
            <BirthDateField label={textMap.dateOfBirth} path={PATH_DATE_OF_BIRTH} required={true} />
            <GenderField label={textMap.gender} path={PATH_GENDER} required={true} />
            <CountryField label={textMap.nationality} path={PATH_NATIONALITY} required={true} />
            <CIS4mTextField label={textMap.hometown} path={PATH_HOME_TOWN} hidden={!showHomeTownField} />
            <LanguageField label={textMap.language} path={PATH_LANGUAGE} required={true} />
            <ReligionField label={textMap.religion} path={PATH_RELIGION} required={true} />
            <AHVField
                label={textMap.ahv}
                helperText={textMap.ahvHelpText}
                path={PATH_AHV}
                required={true}
                mask={'7569999999999'}
                checkValidity={validateAHVNoDots}
            />
        </ECheckinSection>
    );
});

PersAngaben.displayName = 'PersAngaben';

export default PersAngaben;
